import * as React from 'react'

import {
  Button
} from '@fluentui/react-components'
import { FilterRegular } from '@fluentui/react-icons'

const FilterButton = (props) => {
  const { setIsOpenFilterPanel } = props

  return (
    <Button icon={<FilterRegular />} onClick={() => setIsOpenFilterPanel((prev) => !prev)} />
  )
}

export default FilterButton
